<template>
    <div class="featured-resource ">
        <pageSearch  :isNewPage="false" @banner_search="banner_search" :tit="tit"></pageSearch>
        <div class="page-cont">   
            <ul class="two-nav" v-if="navList.length!=0">
                <li class="nav-label" :class="(index+1)==twoNavIndex?'active':''" v-for="(item,index) in navList" :key="index" @click="twoNav_click(item,index)">{{ item.name }}</li>
            </ul> 
            <ul class="three-nav">
                <li  class="nav-list" :class="(index+1)==threeNavIndex?'active':''" v-for="(item,index) in twoNav" :key="index" @click="threeNav_click(item,index)">{{ item.name }}</li>
            </ul>
            <div v-loading="listLoad" >
                <div v-if="listInfo&&listInfo.length!=0">
                    <ul class="resource-list" >
                        <li v-for="(item,index) in listInfo" :key="index" class="list" @click="jump_prompt(item)">
                            <p class="list-tit" v-html="item.resource_row"></p>
                            <div class="list-cont">
                                <div class="info-txt" v-for="(list,num) in item.subtitleList" :key="num">
                                    <b>[{{ list.label }}]：</b>
                                    <p v-html="list.text"></p>
                                </div> 
                            </div>
                            
                        </li>
                    </ul>
                    <el-pagination  
                        class="page-wrap"  
                        @current-change="changePage" 
                        @size-change="sizeChange"
                        background
                        :current-page="pageInfo.pageNum" 
                        :page-count="pageInfo.pageTotal" 
                        :page-size="pageInfo.pageSize"
                        :page-sizes="[9, 18, 27, 45, 90]"
                        :total="pageInfo.total"
                        layout="total, sizes, prev, pager, next, jumper" >
                    </el-pagination>
                </div>
                <p v-else class="no-data">暂无数据～</p>
            </div>
        </div>
        <deductScore ref="deduct_score" v-if="isShowTip" :show.sync="isShowTip"></deductScore>
    </div>
</template>

<script>
import deductScore from '../comps/deduct_score.vue'
import {globalSearchTree,resourceSearch,} from '../../io/api.js'
import pageSearch from '../comps/page_search.vue'
export default {
    components:{
        pageSearch,
        deductScore
    },
    data () {
        return {
            tit:this.$route.query.word||'',
            link:this.$route.query.link||'', 
            oneLabel:this.$route.query.label||'', 
            tableVal:this.$route.query.table||'',
            searchVal:'',
            listLoad:false,
            navList:[],
            twoNavIndex:'',
            twoNav:[], 
            threeNavIndex:'',
            
            listInfo:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 9,
            },
            isShowTip:false,
             
        }
    },
    mounted(){
        this.getList();
       
    },
    methods:{
         //banner检索
        banner_search(val){ 
            this.searchVal=val;
            this.getList(1); 
            this.tableVal='';
            this.get_resourceSearch(1)
        }, 
        twoNav_click(item,index,click=true){ 
            this.twoNavIndex=index+1;
            this.threeNavIndex='';
            this.twoNav=item.children||[];
            //选中2级目录，自动默认三级菜单第一个个选项
            if(item.children){
                if(click){
                    this.threeNav_click(item.children[0],0)
                }else{
                    item.children.forEach((list,num) => {
                        if(list.tableValue==this.tableVal){
                            this.threeNav_click(list,num)
                        }
                    }); 
                }
            } 
            /*--选中2级目录下所有数据--*/ 
            // let tableValArr=[];  
            // if(item.children){
            //     item.children.forEach(list => {
            //         tableValArr.push(list.tableValue) 
            //     });
            //     this.tableVal=tableValArr.join(','); 
            // } 
            // this.get_resourceSearch(1)
           
        },
        threeNav_click(item,index){
            this.threeNavIndex=index+1  ;
            this.tableVal=item.tableValue;
            this.get_resourceSearch(1)
        },
        getList(){
            let params={
                link: this.link,
                table: this.tableVal||'',
                keywords:this.searchVal, 
            } 
            globalSearchTree(params).then(res=>{
                let {code,msg,data}=res.data;
                if(code==0){
                    this.navList=data.treeStructure.length!=0&&data.treeStructure[0].children||[];   
                    
                    //同时存在label和table，首页三级过来的
                    if(this.oneLabel&&this.tableVal){
                        this.navList&&this.navList.forEach((item,index)=>{
                            if(item.label==this.oneLabel){ 
                                this.twoNav_click(item,index,false)
                            }
                        })
                    }else{ 
                        this.twoNav_click(this.navList[0],0)
                    }
                    
                }else{
                    this.$message.error('请求失败～')
                }
                 this.treeLoad=false;
            })
        },
        get_resourceSearch(num){
            this.listLoad=true;
            this.pageInfo.pageNum=num?num:this.pageInfo.pageNum
            let params={
                link:this.link,
                table:this.tableVal,
                searchWord:this.searchVal,
                secondSearchWord:'',
                page: this.pageInfo.pageNum,
                limit: this.pageInfo.pageSize,

            }
            resourceSearch(params).then(res=>{
                let {code,msg,data}=res.data;
                if(code==0){
                    this.listInfo=data.list||[];
                    this.pageInfo.total=data.totalCount;
                }else{
                    this.$message.error('检索失败～')
                }
                this.listLoad=false;
            })
        },
        jump_prompt(item){
            this.isShowTip=true; 
            this.$nextTick(()=>{
                let searchWord=this.searchVal?this.searchVal:'';
                this.$refs.deduct_score.get_checkScoreStatus(item,searchWord)
            })
        },
        changePage(num) {
            this.pageInfo.pageNum = num; 
            this.get_resourceSearch()
        },
        sizeChange(val) {
             this.pageInfo.pageSize=val;
             this.get_resourceSearch()
        },
    }
}
</script>

<style lang="less" scoped>
.featured-resource{
    // .resource-tit{
    //     // text-align: center;
    //     font-size: 24px;
    //     font-weight: bold;
    //     line-height: 40px;
    // }
    // .resource-search{
    //     padding:20px 0;
        
    //     ::v-deep .el-input-group__append{
    //         background: #396de7;
    //         border: 1px solid #396de7;
    //         color: #fff; 
    //     }
    // }
    .two-nav{
        display: flex;
        flex-wrap: wrap;
        border-bottom:2px solid #386DE8;
        .nav-label{
            font-weight: bold;
            font-size: 18px;
            flex-shrink: 1;
            // width: 150px;
            padding:0 40px;
            height: 40px;
            line-height: 40px;
            //margin:0 0px 10px 0;
            background: #fff;//#FCFCFC;
            border: 1px solid #fff;
            border-radius: 4px 4px 0 0;
            text-align: center;
            cursor: pointer;
            &:hover, &.active{
                color: #386DE8;
                border-bottom: none;
            }
        }
    }
    .navHover{
        background: #EAF1FF;
        border : 1px solid #A0BDFF;
        box-shadow: 0px 2px 4px 0px rgba(22,93,255,0.1);
        color: #386DE8;
    }
    .three-nav{
        padding-top:20px;
        display: flex;
        flex-wrap: wrap;
        margin-right: -30px;
        .nav-list{
            width: 180px;
            height: 40px;
            font-size: 16px;
            line-height: 40px; 
            border: 1px solid #E9ECEF;
            text-align: center;
            margin-right: 24px;
            margin-bottom: 10px;
            cursor: pointer;
            &:hover, &.active{
                .navHover();
            }
        }
    }

    .resource-list{
        font-size: 16px;
        display: flex;
        text-align: center;
        flex-wrap: wrap;
        padding-top: 20px;
        margin-right: -100px;
        .list{
            width: 390px;
            height: 120px;
            padding:10px;
            // background: #EAF1FF;
            margin :0 20px 20px 0;
            background: url('../../assets/images/resource/border.png') no-repeat right bottom;
            background-size:contain;
            box-shadow:6px 8px 10px 0px #d3d8dc;
            cursor: pointer;
            .list-tit{
                // font-weight: bold;
                font-size: 16px;
                text-align: left;
                padding-bottom: 10px;
                white-space:nowrap;//(文字不换行);
                overflow:hidden;//( 溢出隐藏);
                text-overflow:ellipsis;//( 文本有溢出加省略号 );
            }
            .list-cont{
                overflow: hidden;
                height: 60px;
            }
            .list-info{
                width:980px ;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                p{
                    width: 220px;
                    border:1px solid #ccc;
                    margin-right: 20px;
                    line-height: 40px;
                    margin-bottom: 20px;
                    color: #396de7;
                }
            }
            .info-txt{
                line-height: 30px;
                display: flex;  
                font-size: 14px; 
                b{
                    white-space: nowrap;
                }
                p{
                    white-space:nowrap;//(文字不换行);
                    overflow:hidden;//( 溢出隐藏);
                    text-overflow:ellipsis;//( 文本有溢出加省略号 );
                    display:inline-block;//(flex布局)
                }
            }

        }
    }
    .no-data{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        min-height: 400px;
    }
}
</style>